import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
export function Colgroup(_ref) {
  var descriptors = _ref.descriptors;
  return /*#__PURE__*/React.createElement("colgroup", null, _mapInstanceProperty(descriptors).call(descriptors, function (descriptor) {
    if (descriptor.type === 'blank') {
      return /*#__PURE__*/React.createElement("col", {
        key: descriptor.blankSide,
        style: {
          width: descriptor.width
        }
      });
    }
    return /*#__PURE__*/React.createElement("col", {
      key: descriptor.colIndex,
      style: {
        width: descriptor.col.width
      }
    });
  }));
}